import { useEffect, useState } from "react";
import API from "../../services/api";
import toast from "react-hot-toast";

function DirectDueModal({
    open,
    onClose,
    customer,
    onSuccess
}) {

    const [wallets, setWallets] = useState([]);

    const [loading, setLoading] = useState(false);

    const [form, setForm] = useState({
        type: "due",
        wallet_id: "",
        amount: "",
        remarks: ""
    });

    useEffect(() => {

        if (!open) return;

        loadWallets();

        setForm({
            type: "due",
            wallet_id: "",
            amount: "",
            remarks: ""
        });

    }, [open]);

    const loadWallets = async () => {

        try {

            const res = await API.get("/wallets");

            setWallets(
                res.data.wallets
            );

        } catch (err) {

            console.log(err);

        }

    };

    const submit = async (e) => {

        e.preventDefault();

        if (!form.amount) {

            toast.error(
                "Enter Amount"
            );

            return;

        }

        if (
            form.type === "pay" &&
            !form.wallet_id
        ) {

            toast.error(
                "Select Wallet"
            );

            return;

        }

        try {

            setLoading(true);

            const res =
                await API.put(
                    `/customers/${customer.id}/direct-due`,
                    form
                );

            toast.success(
                res.data.message
            );

            onSuccess();

            onClose();

        } catch (err) {

            console.log(err);

            toast.error(
                err.response?.data?.message ||
                "Something went wrong."
            );

        } finally {

            setLoading(false);

        }

    };

    if (!open) return null;

    return (

        <div
            className="
fixed
inset-0
z-50
bg-black/60
flex
items-center
justify-center
p-4
"
        >

            <div
                className="
                bg-white
                rounded-2xl
                w-full
                max-w-lg
                shadow-2xl
                overflow-hidden
                text-dark
                "
            >

                <div
                    className="
                    bg-yellow-500
                    px-6
                    py-4
                    flex
                    items-center
                    justify-between
                    "
                >

                    <div>

                        <h2
                            className="
text-xl
font-bold
text-black
"
                        >
                            Update Direct Due
                        </h2>

                        <p
                            className="
text-sm
text-black/70
"
                        >
                            {customer.customer_name}
                        </p>

                    </div>

                    <button
                        onClick={onClose}
                        className="
text-2xl
font-bold
text-black
"
                    >
                        ×
                    </button>

                </div>

                <form
                    onSubmit={submit}
                    className="p-6 space-y-5"
                >

                    <div>

                        <label
                            className="
block
font-semibold
mb-2
"
                        >
                            Current Direct Due
                        </label>

                        <div
                            className="
bg-red-50
border
border-red-200
rounded-xl
p-4
text-red-600
font-bold
text-lg
"
                        >
                            ₹
                            {Number(
                                customer.direct_due || 0
                            ).toFixed(2)}
                        </div>

                    </div>

                    <div>

                        <label
                            className="
block
font-semibold
mb-2
"
                        >
                            Type
                        </label>

                        <select
                            value={form.type}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    type:
                                        e.target.value,
                                    wallet_id: ""
                                })
                            }
                            className="
w-full
border
rounded-xl
p-3
"
                        >
                            <option value="due">
                                Add Due
                            </option>

                            <option value="pay">
                                Receive Payment
                            </option>

                        </select>

                    </div>

                    {
                        form.type ===
                        "pay" && (

                            <div>

                                <label
                                    className="
block
font-semibold
mb-2
"
                                >
                                    Wallet
                                </label>

                                <select
                                    value={
                                        form.wallet_id
                                    }
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            wallet_id:
                                                e.target
                                                    .value
                                        })
                                    }
                                    className="
w-full
border
rounded-xl
p-3
"
                                >

                                    <option value="">
                                        Select Wallet
                                    </option>

                                    {
                                        wallets.map(
                                            wallet => (

                                                <option
                                                    key={
                                                        wallet.id
                                                    }
                                                    value={
                                                        wallet.id
                                                    }
                                                >

                                                    {
                                                        wallet.wallet_name
                                                    }

                                                    {" - ₹"}

                                                    {
                                                        Number(
                                                            wallet.balance
                                                        ).toFixed(
                                                            2
                                                        )
                                                    }

                                                </option>

                                            )
                                        )
                                    }

                                </select>

                            </div>

                        )
                    }

                    <div>

                        <label
                            className="
block
font-semibold
mb-2
"
                        >
                            Amount
                        </label>

                        <input
                            type="number"
                            min="1"
                            value={
                                form.amount
                            }
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    amount:
                                        e.target.value
                                })
                            }
                            className="
w-full
border
rounded-xl
p-3
"
                            placeholder="Enter Amount"
                        />

                    </div>

                    <div>

                        <label
                            className="
block
font-semibold
mb-2
"
                        >
                            Remarks
                        </label>

                        <textarea
                            rows="3"
                            value={
                                form.remarks
                            }
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    remarks:
                                        e.target.value
                                })
                            }
                            className="
w-full
border
rounded-xl
p-3
resize-none
"
                            placeholder="Remarks"
                        />

                    </div>

                    <div
                        className="
flex
justify-end
gap-3
pt-2
"
                    >

                        <button
                            type="button"
                            onClick={onClose}
                            className="
px-5
py-3
rounded-xl
bg-gray-200
font-semibold
"
                        >
                            Cancel
                        </button>

                        <button
                            type="submit"
                            disabled={loading}
                            className="
px-6
py-3
rounded-xl
bg-yellow-500
text-black
font-bold
disabled:opacity-50
"
                        >
                            {
                                loading
                                    ? "Saving..."
                                    : "Save"
                            }
                        </button>

                    </div>

                </form>

            </div>

        </div>

    );

}

export default DirectDueModal;